export const webAppCache = {} as any;

export function setWebAppCacheData(id: any, data: any) {
  webAppCache[id] = data;
}

export function getWebAppCacheData(id: any) {
  return webAppCache[id];
}
